/* eslint-disable jira/filename-case */
import { KNOWN_TRACE_ID_HEADERS } from './constants.tsx';

export const getTraceId = (response: Response): string | undefined => {
	const traceIdHeader = KNOWN_TRACE_ID_HEADERS.find((header) => response.headers.has(header));
	return traceIdHeader === undefined
		? undefined
		: (response.headers.get(traceIdHeader) ?? undefined);
};

/**
 * Util to get the traceId from a jQuery XHR object.
 * Intended for use with creating FetchErrors from WRM'd components that return jQuery XHR objects
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTraceIdJq = (jqxhr: any): string | undefined => {
	if (!jqxhr || !jqxhr.getResponseHeader) {
		// prefer a silent fail, so we don't accidentally swallow the original error being built
		return undefined;
	}

	const traceIdHeader = KNOWN_TRACE_ID_HEADERS.find(
		(header) => jqxhr.getResponseHeader(header) != null,
	);
	return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};
